export default {
  data: {
    $el: $('#survey_listing'),
    surveys: [],
    paginator: null,
    course_id: null
  },
  methods: {
    bindData: function (data) {
      this.paginator = data.paginator;
      this.surveys = data.surveys;
    },
    deleteSurvey: function (item, event) {
      var self = this;
      var url = Kadenze.Routes.course_coursework_path(self.course_id, item.id);
      var method = 'DELETE';
      var deletePrompt = 'Are you sure you want to delete this survey from the course?';

      Kadenze.UIUtil.confirmAction(deletePrompt, function() {

        var request = new Kadenze.AjaxRequest({
          url: url,
          method: method,
          loadingIndicator: {
            container: self.$el
          }
        });

        request.done(function(data) {
          self.surveyListing(null, true);
          new Kadenze.Notice.success({ message: data.message });
        });

        request.fail(function(xhr, textStatus, errorThrown) {
          new Kadenze.Notice.error({ message: xhr.responseJSON.message });
        });
      });
    },
    surveyListing: function (url, currentPage) {
      var self = this;
      Kadenze.UIUtil.showLoadingIndicator(self.$el);

      //load the entries info from the server
      var page = currentPage ? $('.active.page').text().trim() : null;
      var url = url ? url : Kadenze.Routes.course_surveys_path(self.course_id, {page: page});

      $.ajax({
        type: 'GET',
        url: url,
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        }
      }).success(function(data) {
        self.bindData(data);
      }).error(function(data) {
        console.warn('error retrieving survey data');
        console.log(data);
      }).always(function(data){
        Kadenze.UIUtil.hideLoadingIndicator(self.$el);
        Kadenze.PaginationBinding.applyBindingsWithTextInput(self.surveyListing);
      });
    }
  },
  beforeMount: function () {
    this.course_id = this.$el.dataset.courseId;
  },
  mounted: function () {
    Kadenze.PaginationBinding.applyBindingsWithTextInput(this.surveyListing);
  }
};
